import CallLogModal from './CallLogModal';

export default CallLogModal;
